import React from 'react';
import {
  openExternalLink,
  openExternalLinkSimple,
} from 'utils/openExternalLink';

interface ExternalLinkProps {
  url: string;
  children: any;
  openInNewTab?: boolean;
  onClick?: (e: any) => void;
  noAuth?: boolean;
  [key: string]: any;
}

function ExternalLink({
  url,
  children,
  openInNewTab,
  onClick,
  noAuth,
  ...props
}: ExternalLinkProps) {
  const onLinkClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick(e);
    }
    if (noAuth) {
      return openExternalLinkSimple(url, openInNewTab);
    }
    return openExternalLink(url, openInNewTab);
  };

  return (
    <a onClick={onLinkClick} href={url} {...props}>
      {children}
    </a>
  );
}

export default ExternalLink;
